import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressSummaryFormUS = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({
    slideIds: ['address', 'addressOptions'],
  });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  // Fields houseno* apartment street* city* state* zipcode*

  const housenoField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'houseno'),
    message: s.dataSummary.requiredMessage!,
  });
  const housenoLabel = translate(housenoField?.label);

  const apartmentNoField = s.address.fields.find(({ name }) => name === 'apartment');
  const apartmentNoLabel = translate(apartmentNoField?.label);

  const streetField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'street'),
    message: s.dataSummary.requiredMessage!,
  });
  const streetLabel = translate(streetField?.label);

  const cityField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'city'),
    message: s.dataSummary.requiredMessage!,
  });
  const cityLabel = translate(cityField?.label);

  const stateField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'state'),
    message: s.dataSummary.requiredMessage!,
  });
  const stateLabel = translate(stateField?.label);
  const stateValue =
    translate(stateField?.options?.find(({ value }) => value == getFieldValue('state'))?.label) ||
    getFieldValue('state');

  const zipcodeField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'zipcode'),
    message: s.dataSummary.requiredMessage!,
  });
  const zipcodeLabel = translate(zipcodeField?.label);

  return (
    <div className="summary-card" data-cy={'summary-form-address'}>
      <h2>{translate(s.dataSummary.titles?.address)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{housenoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('houseno')}
          {editMode && <EditDataField field={housenoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{streetLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('street')}
          {editMode && <EditDataField field={streetField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{apartmentNoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('apartment')}
          {editMode && <EditDataField field={apartmentNoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{cityLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('city')}
          {editMode && <EditDataField field={cityField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{stateLabel}</div>
        <div className={'value'}>
          {!editMode && stateValue}
          {editMode && <EditDataField field={stateField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{zipcodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('zipcode')}
          {editMode && <EditDataField field={zipcodeField!} slideId={'address'} />}
        </div>
      </div>
    </div>
  );
};
